import React from 'react';
import {
    Scale, Ruler, Droplets, Bone, Stethoscope,
    ChevronRight, Info, CheckCircle2, Shield,
    HeartPulse, ActivitySquare
} from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import MedidasCard from './MedidasCard';
import PielPelajeCard from './PielPelajeCard';
import SaludDentalCard from './SaludDentalCard';

const HealthViewCard = ({ healthView }) => {
    if (!healthView) return null;

    const { medidas, pielYPelaje, saludDental } = healthView;

    return (
        <Card className="overflow-hidden">
            {/* Header Principal */}
            <CardHeader className="bg-gradient-to-r from-blue-50 to-indigo-50 p-3 sm:p-4 border-b">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                    <div>
                        <CardTitle className="flex items-center gap-2 text-blue-700 text-lg sm:text-lg">
                            <Stethoscope className="h-4 w-4 sm:h-5 sm:w-5" />
                            Estado de Salud
                        </CardTitle>
                        <p className="text-sm text-gray-500 mt-0.5">Evaluación física detallada</p>
                    </div>
                </div>
            </CardHeader>

            <CardContent className="p-3 sm:p-6 space-y-6">
                {/* Sección Medidas */}
                <MedidasCard medidas={medidas} />
                <PielPelajeCard pielYPelaje={pielYPelaje} />

                {/* Sección Salud Dental */}
                <SaludDentalCard saludDental={saludDental} />
            </CardContent>
        </Card>
    );
};

export default HealthViewCard;